function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }





const wm = new WeakMap();

const define = (target, name, value) => {
  Object.defineProperty(target, name, {
    configurable: true,
    writable: true,
    value,
  });
};

const dispatch = (x, event) => {
  const { options } = x;

  if (typeof options === 'object' && 'once' in options && options.once) {
    x.target.removeEventListener(event.type, x.callback);
  }

  if (typeof x.callback === 'function') {
    x.callback.call(x.target, event);
  } else {
    _optionalChain([x, 'access', _ => _.callback, 'optionalAccess', _2 => _2.handleEvent, 'call', _3 => _3(event)]);
  }
};

class EventTargetPolyfill {constructor() { EventTargetPolyfill.prototype.__init.call(this);EventTargetPolyfill.prototype.__init2.call(this);EventTargetPolyfill.prototype.__init3.call(this);EventTargetPolyfill.prototype.__init4.call(this);EventTargetPolyfill.prototype.__init5.call(this);EventTargetPolyfill.prototype.__init6.call(this); }
  __init() {this.addEventListener = (
    type,
    callback,
    options
  ) => {
    const secret = _nullishCoalesce(wm.get(this), () => ( {}));
    const listeners = _nullishCoalesce(secret[type], () => ( new Set()));

    secret[type] = listeners;
    wm.set(this, secret);

    listeners.add({ target: this, callback, options });
  };}

  __init2() {this.dispatchEvent = (event) => {
    const secret = wm.get(this);
    if (!secret) return false;

    const listeners = secret[event.type];

    if (listeners) {
      define(event, 'target', this);
      define(event, 'currentTarget', this);

      [...listeners].forEach((x) => dispatch(x, event), event);
    }
    return true;
  };}

  __init3() {this.removeEventListener = (
    type,
    callback,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _options
  ) => {
    const secret = _nullishCoalesce(wm.get(this), () => ( {}));
    const listeners = _nullishCoalesce(secret[type], () => ( []));

    secret[type] = listeners;
    wm.set(this, secret);

    listeners.forEach((listener) => {
      if (listener.callback === callback) {
        listeners.delete(listener);
      }
    });
  };}

  __init4() {this.on = this.addEventListener;}

  __init5() {this.off = this.removeEventListener;}

  __init6() {this.once = (
    type,
    callback
  ) => {
    this.addEventListener(type, callback, { once: true });
  };}
}

class CustomEventPolyfill extends Event {
  

  constructor(message, data) {
    super(message, data);
    this.detail = data.detail;
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars


const createEventName = (value = Math.random().toString(36)) => {
  return value ;
};

class Event$1 extends CustomEvent {
  constructor(eventName, eventDetail) {
    super(eventName , { detail: eventDetail });
  }
}





class Target {constructor() { Target.prototype.__init.call(this);Target.prototype.__init2.call(this);Target.prototype.__init3.call(this);Target.prototype.__init4.call(this);Target.prototype.__init5.call(this);Target.prototype.__init6.call(this);Target.prototype.__init7.call(this); }
   __init() {this.eventListener = new EventTargetPolyfill();}

  __init2() {this.addEventListener = (
    type,
    listener,
    options
  ) => {
    return this.eventListener.addEventListener(
      type ,
      listener ,
      options
    );
  };}

  __init3() {this.dispatchEvent = (event) => {
    return this.eventListener.dispatchEvent(event);
  };}

  __init4() {this.removeEventListener = (
    type,
    callback,
    options
  ) => {
    return this.eventListener.removeEventListener(
      type ,
      callback ,
      options
    );
  };}

  __init5() {this.on = this.addEventListener;}

  __init6() {this.off = this.removeEventListener;}

  __init7() {this.fire = this.dispatchEvent;}
}

export { CustomEventPolyfill as CustomEvent, Event$1 as Event, EventTargetPolyfill as EventTarget, Target, createEventName };
//# sourceMappingURL=module.js.map
